export const formatHtml = (text = "") =>
  text
    .replace(/className=/g, "class=")
    .replace(/target="_blank"\s+and\s+rel=/g, 'target="_blank" rel=');
